import { DataService } from './../data.service';
import { Injectable } from '@angular/core';
// import { DataService } from '../data.service';
import { environment } from '../../../environments/environment';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonFunctionService, UserMerchantData } from '../Common/common-function.service';
import { PosUserResponse } from '../../models/pos-user-response';
import { AuthService } from '../auth.service';
@Injectable()
export class RegisterService {
  headers: any;
  token: any;
  header: any;
  constructor(private service: AuthService, private dataservice: DataService, private http: HttpClient, private common: CommonFunctionService) {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid();
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }
  registerUser(data) {
    return this.service.signup(data);
  }

  uploadFiles(data, MerchantKeyId, filetype) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.MerchantFileUpload + '?MerchantKeyId=' + MerchantKeyId + '&filetype=' + filetype, data, { headers: this.headers });
  }

  uploadFileslogo(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.MerchantFileUpload + '?MerchantKeyId=' + MerchantKeyId + '&filetype=' + 12 + '&LoginUserId=' + merchantdata.UserId, data, { headers: this.headers });
  }
  MerchantOnboardFileUpload(data, MerchantKeyId, filetype, Aadharverifyvalue) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.MerchantOnboardFileUpload + '?MerchantKeyId=' + MerchantKeyId + '&filetype=' + filetype + '&Aadharverificationcode=' + Aadharverifyvalue + '&LoginUserId=' + merchantdata.UserId, data, { headers: this.headers });
  }
  isEmailIdExist(data) {
    this.GetUserAuthdetails();
    return this.http.get<PosUserResponse>(environment.checkAdminEmailIdUrl + '?email=' + data, { headers: this.headers });
  }
  isMobileExist(data) {
    //  this.GetUserAuthdetails();
    return this.http.get<PosUserResponse>(environment.checkAdminMobileUrl + '?Mobile=' + data, { headers: this.headers });
  }


  GetHeaderdetails() {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));


  }
  RefreshToken(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData(); 
    let token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() +':'+ merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().set('Authorization', 'basic ' + btoa(token));
    return this.http.post(environment.InternalAuthenticate, data, { headers: this.headers });
  }

  GetUserAuthdetails() {
    this.token = "" + ":" + environment.GetAuthenticationToken + ":" + 'IT';
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }
}






